import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { LimeBandCTA } from '../components/LimeBandCTA';
import ClientLogos from '../components/ClientLogos';
import { Link } from 'react-router-dom';
export function Home() {
  const [rotation, setRotation] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const rotationDegrees = scrollPosition * 0.2;
      setRotation(rotationDegrees);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-241">
      <Navbar data-id="element-242" />
      <main className="flex-grow" data-id="element-243">
        {/* Hero Section - Simple headline only */}
        <section className="pt-32 md:pt-48 pb-12 md:pb-20 bg-white" data-id="element-244">
          <div className="container mx-auto px-4 md:px-12" data-id="element-245">
            <div className="max-w-4xl" data-id="element-246">
              <h1 className="font-poppins font-normal text-3xl md:text-5xl text-black leading-tight" data-id="element-247">
                Change happens to people.
                <br data-id="element-248" />
                Progress happens through
                <br data-id="element-249" />
                people.
              </h1>
            </div>
          </div>
        </section>
        {/* Full Width Home Image 1 */}
        <div className="w-full aspect-[21/9] overflow-hidden" data-id="element-250">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nXwaeoEQEZJFV4SYhibeRR/Home_Image_1.jpg" alt="Geometric architectural pattern with green and teal glass" className="w-full h-full object-cover" data-id="element-251" />
        </div>
        {/* Get in Touch CTA Band */}
        <LimeBandCTA linkText="Let's Connect" href="/contact" data-id="element-252" />
        {/* Opportunity Section - Centered */}
        <section className="py-12 md:py-20 bg-white" data-id="element-253">
          <div className="container mx-auto px-4 md:px-12" data-id="element-254">
            <div className="max-w-4xl mx-auto text-center" data-id="element-255">
              <h2 className="font-poppins font-normal text-3xl md:text-4xl text-black mb-6" data-id="element-256">
                Our belief
              </h2>
              <div className="space-y-4" data-id="element-257">
                <p className="font-inter text-base md:text-lg leading-relaxed text-black" data-id="element-258">
                  Progress requires two things: something to believe in, and
                  believers empowered to express it - or purpose and people. We
                  believe you can't successfully move one without the other. We
                  also believe the key to "how" is hidden in the siloed
                  conversations unfolding across your company.
                </p>
                <p className="font-inter text-base md:text-lg leading-relaxed text-black" data-id="element-259">
                  We help business leaders surface the ideas buried in those
                  conversations to answer two basic questions: what do you want
                  to be known for? And what do you need to change for the world
                  to realize it?
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Home Image 2 - Centered, smaller */}
        <section className="py-8 md:py-12 bg-white" data-id="element-260">
          <div className="container mx-auto px-4 md:px-12" data-id="element-261">
            <div className="max-w-[170px] mx-auto" data-id="element-262">
              <div className="w-full aspect-square overflow-hidden rounded-lg" data-id="element-263">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8JnCnwFgpu5hq3nksuUQDp/Home_Image_2.png" alt="Abstract geometric pattern" className="w-full h-full object-cover" style={{
                transform: `rotate(${rotation}deg)`,
                transition: 'transform 0.1s linear'
              }} data-id="element-264" />
              </div>
            </div>
          </div>
        </section>
        {/* Offering Section - Centered headline and intro */}
        <section className="py-12 md:py-20 bg-white" data-id="element-265">
          <div className="container mx-auto px-4 md:px-12" data-id="element-266">
            <div className="max-w-4xl mx-auto text-center mb-12 md:mb-16" data-id="element-267">
              <h2 className="font-poppins font-normal text-3xl md:text-4xl text-black mb-6" data-id="element-268">
                People Effectiveness Partner
              </h2>
              <p className="font-inter text-base md:text-lg leading-relaxed text-black" data-id="element-269">
                People don't get more effective by accident. Real progress takes
                perspective, purpose, principles, and practice, so every change
                lands where the work happens. That's where we focus.
              </p>
            </div>
            {/* Offering Grid - Alternating images and content */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-270">
              {/* Row 1: Home Image 3 | Offering 1 (Perspective) */}
              <div className="aspect-[4/3] rounded-lg overflow-hidden" data-id="element-271">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3oR6H9tZVB11XzvwiegNoV/Home_image_3.jpg" alt="Modern architectural staircase detail" className="w-full h-full object-cover" data-id="element-272" />
              </div>
              <div className="bg-white rounded-lg p-6 md:p-8 h-full flex flex-col justify-center" data-id="element-273">
                <h3 className="font-poppins font-normal text-2xl md:text-3xl text-black mb-2" data-id="element-274">
                  Perspective
                </h3>
                <p className="font-inter text-base md:text-lg text-black mb-4" data-id="element-275">
                  What to fix, where it counts.
                </p>
                <p className="font-inter text-base leading-relaxed text-black mb-4" data-id="element-276">
                  Your people are telling you what's helping, and what's holding
                  them back. Huwey (our AI platform) translates their
                  unstructured feedback into answers, showing you the
                  perceptions, drivers, and priorities that unlock performance.
                </p>
                <Link to="/perspective" className="font-inter font-semibold inline-flex items-center text-black hover:text-lime transition-colors group" data-id="element-277">
                  Learn More
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-1" data-id="element-278">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-279" />
                  </svg>
                </Link>
              </div>
              {/* Row 2: Home Image 4 | Offering 2 (Purpose) */}
              <div className="aspect-[4/3] rounded-lg overflow-hidden" data-id="element-280">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hEeLcCWariX9pD9e9ZS4Lt/Home_Image_4.jpg" alt="Macro nature pattern with green organic texture" className="w-full h-full object-cover" data-id="element-281" />
              </div>
              <div className="bg-white rounded-lg p-6 md:p-8 h-full flex flex-col justify-center" data-id="element-282">
                <h3 className="font-poppins font-normal text-2xl md:text-3xl text-black mb-2" data-id="element-283">
                  Purpose
                </h3>
                <p className="font-inter text-base md:text-lg text-black mb-4" data-id="element-284">
                  Say less. Mean more.
                </p>
                <p className="font-inter text-base leading-relaxed text-black mb-4" data-id="element-285">
                  What you stand for should be obvious—not just to marketing,
                  but to every team, partner, and customer. Our Positioning
                  Services help you define a point of view big enough to move
                  markets and practical enough to scale across the business.
                </p>
                <Link to="/purpose" className="font-inter font-semibold inline-flex items-center text-black hover:text-lime transition-colors group" data-id="element-286">
                  Learn More
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-1" data-id="element-287">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-288" />
                  </svg>
                </Link>
              </div>
              {/* Row 3: Home Image 5 | Offering 3 (Principles) */}
              <div className="aspect-[4/3] rounded-lg overflow-hidden" data-id="element-289">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/avrgvoGdP4i3rEbEjzCB3x/Home_Image_5.jpg" alt="Abstract layered pattern with teal and sand tones" className="w-full h-full object-cover" data-id="element-290" />
              </div>
              <div className="bg-white rounded-lg p-6 md:p-8 h-full flex flex-col justify-center" data-id="element-291">
                <h3 className="font-poppins font-normal text-2xl md:text-3xl text-black mb-2" data-id="element-292">
                  Principles
                </h3>
                <p className="font-inter text-base md:text-lg text-black mb-4" data-id="element-293">
                  Change the experience. Transform the business.
                </p>
                <p className="font-inter text-base leading-relaxed text-black mb-4" data-id="element-294">
                  Plans don't drive progress. People do. Our Transformation
                  Services help you turn strategy into momentum by shifting
                  behaviors, building habits, and empowering leaders to carry
                  transformation into everyday moments.
                </p>
                <Link to="/principles" className="font-inter font-semibold inline-flex items-center text-black hover:text-lime transition-colors group" data-id="element-295">
                  Learn More
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-1" data-id="element-296">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-297" />
                  </svg>
                </Link>
              </div>
              {/* Row 4: Home Image 6 | Offering 4 (Practice) */}
              <div className="aspect-[4/3] rounded-lg overflow-hidden" data-id="element-298">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tFrGaPzxNA4UjBnPUeK3jf/Home_Image_6.jpg" alt="Geometric green brick pattern" className="w-full h-full object-cover" data-id="element-299" />
              </div>
              <div className="bg-white rounded-lg p-6 md:p-8 h-full flex flex-col justify-center" data-id="element-300">
                <h3 className="font-poppins font-normal text-2xl md:text-3xl text-black mb-2" data-id="element-301">
                  Practice
                </h3>
                <p className="font-inter text-base md:text-lg text-black mb-4" data-id="element-302">
                  Move people, not just plans.
                </p>
                <p className="font-inter text-base leading-relaxed text-black mb-4" data-id="element-303">
                  Training explains change. Experiences create it. Our Immersive
                  Experiences strip away hierarchy, simulate real dynamics, and
                  connect new ways of working directly to the places where
                  progress happens.
                </p>
                <Link to="/practice" className="font-inter font-semibold inline-flex items-center text-black hover:text-lime transition-colors group" data-id="element-304">
                  Learn More
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-1" data-id="element-305">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-306" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </section>
        {/* Client Banner */}
        <ClientLogos data-id="element-307" />
        {/* About CTA Section */}
        <section className="py-12 md:py-20 bg-white" data-id="element-308">
          <div className="container mx-auto px-4 md:px-12" data-id="element-309">
            <div className="max-w-4xl mx-auto text-center" data-id="element-310">
              <p className="font-inter text-base md:text-lg leading-relaxed text-black mb-4" data-id="element-311">
                What do a game designer, a product marketer, and a business exec
                have in common?
              </p>
              <p className="font-inter text-base md:text-lg leading-relaxed text-black mb-6" data-id="element-312">
                Turns out, a lot more than we realized.
              </p>
              <Link to="/about" className="inline-flex items-center font-poppins font-normal text-base md:text-lg text-black hover:text-lime transition-colors" data-id="element-313">
                Meet the team
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-2" data-id="element-314">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-315" />
                </svg>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-316" />
    </div>;
}